import { ISequence } from 'interfaces/tagging/ISequence';
import React from 'react';
import { Option } from '../../../Option/Option';
import { FieldingSequencePlayerWrapper } from './FieldingSequencePlayerStyles';

interface IProps {
  onPressHotkeyCallback: (playerNumber: ISequence) => void;
  onClickCallback: (playerNumber: ISequence) => void;
  hotkeyCode: number;
  hotkeyDisplay: string;
  selected: boolean;
}

export const FieldingSequencePlayer: React.FC<IProps> = ({
  onPressHotkeyCallback,
  onClickCallback,
  hotkeyCode,
  hotkeyDisplay,
  selected,
}) => {
  return (
    <FieldingSequencePlayerWrapper className={`position-${hotkeyDisplay} ${selected && 'selected'}`}>
      <Option
        displayName={hotkeyDisplay}
        hotkeyCode={hotkeyCode}
        hotkeyDisplay={hotkeyDisplay}
        value={hotkeyDisplay}
        onPressHotkeyCallback={() => onPressHotkeyCallback(hotkeyDisplay)}
        onClickCallBack={() => onClickCallback(hotkeyDisplay)}
        data-testid={`position-${hotkeyDisplay}`}
      />
    </FieldingSequencePlayerWrapper>
  );
};
